export default "__VITE_ASSET__CJxEvOXb__"